function positionStickyButtons () {
  positionButton()

  function positionButton () {
    const productTable = document.getElementById('productTable')
    const addToBasket = document.getElementById('addToBasket')
    const offset = window.innerWidth < 960 ? 0 : 225

    if (productTable === null || addToBasket === null) return

    const { bottom: productTableBottom, top: productTableTop } = productTable.getBoundingClientRect()
    const addToBasketHeight = addToBasket.getBoundingClientRect().height

    const tableBottomInView = productTableBottom >= window.innerHeight - addToBasketHeight
    const tableTopInView = productTableTop - offset < window.innerHeight

    if (tableBottomInView && tableTopInView) {
      addToBasket.classList.add('sticky-button-fixed')
    } else {
      addToBasket.classList.remove('sticky-button-fixed')
    }
  }

  window.addEventListener('scroll', positionButton)
  window.addEventListener('resize', positionButton)
}

export default positionStickyButtons
